import { render, staticRenderFns } from "./ViewCoutUserSent.vue?vue&type=template&id=11740801&scoped=true"
import script from "./ViewCoutUserSent.vue?vue&type=script&lang=js"
export * from "./ViewCoutUserSent.vue?vue&type=script&lang=js"
import style0 from "./ViewCoutUserSent.vue?vue&type=style&index=0&id=11740801&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11740801",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11740801')) {
      api.createRecord('11740801', component.options)
    } else {
      api.reload('11740801', component.options)
    }
    module.hot.accept("./ViewCoutUserSent.vue?vue&type=template&id=11740801&scoped=true", function () {
      api.rerender('11740801', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notifihistory/ViewCoutUserSent.vue"
export default component.exports